import CommonService from "../Common";
import {
  ActivateAccountRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  SignUpLogInRequest,
} from "../../interfaces/Auth";
import { UpdateAccountRequest } from "../../interfaces/User";
import { AxiosRequestConfig } from "axios";

interface User {
  pathPrefix?: string;
  commonService: CommonService;
}

class UserService implements User {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/user";
    this.commonService = new CommonService();
  }

  signUp({ email, name, password }: SignUpLogInRequest) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/signup`,
      data: {
        email,
        name,
        password,
      },
    };
    return this.commonService.fetch(config);
  }

  activateAccount({ email, activationToken }: ActivateAccountRequest) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/activate`,
      data: {
        email,
        activationToken,
      },
    };
    return this.commonService.fetch(config);
  }

  forgotPassword({ email }: ForgotPasswordRequest) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/forgotpassword`,
      data: { email },
    };
    return this.commonService.fetch(config);
  }

  resetPassword({ email, newPassword, resetToken }: ResetPasswordRequest) {
    const config: AxiosRequestConfig = {
      method: "PUT",
      url: `${this.pathPrefix}/resetpassword`,
      data: {
        email,
        newPassword,
        resetToken,
      },
    };
    return this.commonService.fetch(config);
  }

  updateAccount({
    userID,
    email,
    password,
    updatedAccount,
  }: UpdateAccountRequest) {
    if (updatedAccount.email?.trim() === "") {
      delete updatedAccount.email;
    }
    const config: AxiosRequestConfig = {
      method: "PUT",
      url: `${this.pathPrefix}/update`,
      withCredentials: true,
      data: {
        userID,
        email,
        password,
        updatedAccount,
      },
    };
    return this.commonService.fetch(config);
  }
}

export default UserService;
